import type { QuoteDetailsData } from 'state/quotes/details/details.model';
import type { AppState } from 'state/state.model';

export function getBatchQuoteDetails(state: AppState, formId: string): QuoteDetailsData | undefined {
  return state.batchForm.quoteDetails[formId];
}

export function getBatchQuoteGreekNames(state: AppState, formId: string): string[] {
  const greeks = getBatchQuoteDetails(state, formId)?.Greeks;
  return greeks?.columns.map(x => x.name) ?? [];
}
